const RECENTLY_VIEWED_STORAGE_KEY = 'recently_viewed_product_catalog_ids';
export const MAX_RECENTLY_VIEWED = 20;

export function getRecentlyViewedProductCatalogIds(): number[] {
  if (typeof window === 'undefined' || !window.eventsTracking) return [];
  try {
    const raw = window.eventsTracking.getData(RECENTLY_VIEWED_STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed)
      ? parsed.filter((id): id is number => typeof id === 'number' && Number.isInteger(id))
      : [];
  } catch {
    return [];
  }
}

export function setRecentlyViewedProductCatalogIds(ids: number[]): void {
  if (typeof window === 'undefined' || !window.eventsTracking) return;
  try {
    const valid = ids.filter((id): id is number => typeof id === 'number' && Number.isInteger(id));
    const trimmed = valid.slice(-MAX_RECENTLY_VIEWED);
    window.eventsTracking.setData(RECENTLY_VIEWED_STORAGE_KEY, JSON.stringify(trimmed));
  } catch {
    // ignore
  }
}

function addRecentlyViewedWithLRU(catalogId: number): void {
  const ids = getRecentlyViewedProductCatalogIds();
  const index = ids.indexOf(catalogId);
  let next: number[];
  if (index >= 0) {
    next = ids.filter((_, i) => i !== index);
    next.push(catalogId);
  } else {
    next = ids.length >= MAX_RECENTLY_VIEWED ? ids.slice(1) : [...ids];
    next.push(catalogId);
  }
  setRecentlyViewedProductCatalogIds(next);
}

export function recordRecentlyViewedProductCatalogId(catalogId: number): void {
  addRecentlyViewedWithLRU(catalogId);
}
